const OPTION_IDS = {
    yesterday: 'yesterday',
    thisweek: 'lastWeek',
    last30days: 'last30days',
    quarter: 'quarter',
    sameDayLastMonth: 'sameDayLastMonth',
    last6months: 'last6months',
    last12months: 'last12months',
    yeartodate: 'yeartodate',
    lifetime: 'lifetime',
    custom: 'custom',
    thedaybefore: 'thedaybefore',
    samedaylastweek: 'samedaylastweek',
    questertodate: 'questertodate',
    samedaylastmonth: 'samedaylastmonth',
    samedaylastyear: 'samedaylastyear',
    comparedcustom: 'compared_custom',
};
 
 export {OPTION_IDS};